import React, { useState, useMemo, useEffect, useRef } from "react";
import "./Tabs.css";
import DimensionsTab from "src/components/Tabs/DimensionsTab/DimensionsTab";
import WallsTab from "src/components/Tabs/WallsTab/WallsTab";
import RoofingTab from "src/components/Tabs/RoofingTab/RoofingTab";
import MaterialsListTab from "src/components/Tabs/MaterialsListTab/MaterialsListTab";
import OptiesTab from "src/components/Tabs/OptiesTab/OptiesTab";

import { useView } from "src/contexts/ViewContext";
import RoofTypeTab from "src/components/Tabs/RoofTypeTab/RoofTypeTab";
import { useConfiguration } from "src/contexts/ConfigurationContext";
// @ts-ignore
import { Scrollbars } from "react-custom-scrollbars";
import { getConfigurationHash } from "src/helpers/configuration";
import { useTabScroll } from "src/contexts/TabScrollContext";
import SunScreenTab from "./SunScreenTab/SunScreenTab";
import FunderingTab from "./FunderingTab/FunderingTab";

interface TabConfig {
  id: number;
  title: string;
  component: React.ReactNode;
  description?: string;
}

interface TabProps {
  tab: {
    id: number;
    title: string;
    component: React.ReactNode;
  };
  isActive: boolean;
  onClick: () => void;
  onNext?: (currentTabId: number) => void;
  onPrev?: (currentTabId: number) => void;
  hidden: boolean;
  isCompleted: boolean;
  description?: string;
}

const tabsData: TabConfig[] = [
  {
    id: 1,
    title: "Dak constructie",
    component: <RoofTypeTab />,
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.",
  },
  {
    id: 2,
    title: "Kleur & Dak",
    component: <DimensionsTab />,
    // description:
    //   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.",
  },
  {
    id: 3,
    title: "Wanden",
    component: <WallsTab />,
    // description:
    //   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.",
  },
  {
    id: 4,
    title: "Accessoires",
    component: <SunScreenTab />,
    // description:
    //   "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.",
  },
  // {
  //   id: 5,
  //   title: "Fundering opties",
  //   component: <FunderingTab />,
  // },
  {
    id: 7,
    title: "Materiaallijst",
    component: <MaterialsListTab />,
  },
];

const ArrowIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 12L10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12Z"
      fill="currentColor"
    />
  </svg>
);

// const PrevIcon: React.FC = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="55"
//     height="45"
//     viewBox="0 0 55 45"
//     fill="none"
//   >
//     <path
//       d="M32.0115 14.5898L23.8801 21.394C23.1454 22.0088 23.1454 22.9912 23.8801 23.606L32.0115 30.4102"
//       stroke="currentColor"
//       strokeWidth="2.14844"
//       strokeLinecap="round"
//     />
//   </svg>
// );

const PrevIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M.88 14.09 4.75 18a1.001 1.001 0 1 0 1.42-1.41L2.61 13H23a1 1 0 0 0 1-1 1 1 0 0 0-1-1H2.55l3.62-3.61a1 1 0 0 0 0-1.42 1 1 0 0 0-1.42 0L.88 9.85a3 3 0 0 0 0 4.24Z"
    />
  </svg>
);

// const NextIcon: React.FC = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="12"
//     height="19"
//     viewBox="0 0 12 19"
//     fill="none"
//   >
//     <path
//       d="M1.98849 17.4102L10.1199 10.606C10.8546 9.9912 10.8546 9.0088 10.1199 8.39398L1.98849 1.58984"
//       stroke="white"
//       strokeWidth="2.14844"
//       strokeLinecap="round"
//     />
//   </svg>
// );

const NextIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill="currentColor"
      d="M23.12 9.91 19.25 6a1 1 0 1 0-1.42 1.41L21.39 11H1a1 1 0 0 0-1 1 1 1 0 0 0 1 1h20.45l-3.62 3.61a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.22l3.87-3.88a3 3 0 0 0 0-4.24Z"
    />
  </svg>
);

const InfoIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <g fill="currentColor" clip-path="url(#a)">
      <path d="M12 4.5a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8Zm0 14.667a6.666 6.666 0 1 1 6.667-6.667A6.674 6.674 0 0 1 12 19.167Z" />
      <path d="M12 11.167h-.667a.667.667 0 1 0 0 1.333H12v4a.667.667 0 0 0 1.333 0v-4A1.333 1.333 0 0 0 12 11.167ZM12 9.833a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M4 4.5h16v16H4z" />
      </clipPath>
    </defs>
  </svg>
);

const CheckIcon: React.FC = () => <span>✓</span>;

interface TooltipProps {
  completed: boolean;
}

const Tab: React.FC<TabProps> = ({
  tab,
  isActive,
  onClick,
  hidden,
  onNext,
  onPrev,
  isCompleted,
  description,
}) => {
  if (hidden) return null;

  return (
    <div className="tab" id={`tab-${tab.id}`}>
      <div
        className={`tab-header ${isActive ? "open" : ""} ${
          isCompleted ? "completed" : ""
        }`}
        onClick={onClick}
      >
        <div className="relative">
          {
            // !isCompleted && <InfoIcon />
            // !isCompleted && description && <InfoIcon />
            !isCompleted && (
              <div
                className={`tab-number${description ? " infohovertarget" : ""}${
                  isActive ? " active" : ""
                }`}
              >
                {" "}
                {tab.id}
              </div>
            )

            //   <span id={`tab-number-${tab.id}`}>{tab.id}</span>
          }
          {isCompleted && <CheckIcon />}

          {description && <div className="infohover">{description}</div>}
        </div>
        <span>{tab.title.toUpperCase()}</span>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>
      {isActive && (
        <div className="tab-content">
          {tab.component}
          <div className="tab-navigation">
            {onPrev && (
              <button
                className={"prevButton"}
                onClick={() => {
                  onPrev(tab.id);
                }}
              >
                <PrevIcon />
                Vorige
              </button>
            )}
            {onNext && (
              <button
                className={"nextButton"}
                onClick={() => {
                  onNext(tab.id);
                }}
              >
                {tab.id === tabsData.length - 1 ? "Gereed" : "Volgende"}
                <NextIcon />
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Tabs: React.FC = () => {
  const configurationHash = getConfigurationHash();
  const [activeTabs, setActiveTabs] = useState<Set<number>>(new Set());
  const [completedTabs, setCompletedTabs] = useState<Set<number>>(
    new Set(configurationHash ? tabsData.map((t) => t.id) : [])
  );
  const { isAdmin } = useView();
  const { configurator, setUncompletedTabs, state, setLights } =
    useConfiguration();
  const { scrollRef, scrollTo } = useTabScroll();
  const lastClickWasWanden = useRef<boolean>(false);

  const visibleTabs = useMemo(() => {
    return tabsData.filter((tab) => {
      if (tab.id !== 7) return true;
      return isAdmin();
    });
  }, [isAdmin]);

  const handleOutWandenClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const wandenElement = document.getElementById("tab-5");
    const clickedInsideTab5 = wandenElement
      ? wandenElement.contains(e.target as Node)
      : false;

    if (clickedInsideTab5) {
      lastClickWasWanden.current = true;
    } else {
      if (lastClickWasWanden.current) {
        configurator.resetCamera();
      }

      lastClickWasWanden.current = false;
    }
  };

  const handleTabClick = (id: number) => {
    let newSet = new Set(activeTabs);
    // const
    configurator.resetCamera();

    // if (!state.lights.enabled)
    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }

    if (!newSet.has(id)) {
      newSet = new Set<number>();
      newSet.add(id);

      const posx = window.APP.scene.controls.target.x;
      const posz = window.APP.scene.controls.target.z;

      const width = state.dimensions.width / 1000 / 2;
      const depth = state.dimensions.depth / 1000 / 2;

      // if (posx >= width || posx <= -width || posz >= depth || posz <= -depth)

      // scroll to top
      setTimeout(() => {
        // const tabElement = document.querySelector(`#tab-${id}`);
        // if (tabElement) scrollTo(tabElement);
      }, 80);
    } else {
      newSet = new Set<number>();

      // if (id === 4)
      //   if (state.lights.lightsOn) {
      //     setLights({ ...state.lights, lightsOn: false });
      //   }

      // if (id === 5 || id === 4) {
      // }

      // if (id === 5) {
      //   configurator.resetCamera();
      // }
    }

    configurator.deselectWalls();

    // console.log(newSet);

    setActiveTabs(newSet);
  };

  const goToNextTab = (currentTabId: number) => {
    configurator.resetCamera();
    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }

    const currentIndex = visibleTabs.findIndex((t) => t.id === currentTabId);
    if (currentIndex < 0) return;
    const nextTab = visibleTabs[currentIndex + 1];

    configurator.deselectWalls();

    if (currentTabId === 5) {
      configurator.resetCamera();
    }

    setCompletedTabs((prev) => {
      const newSet = new Set(prev);
      newSet.add(currentTabId);
      return newSet;
    });

    setActiveTabs((prev) => {
      const newSet = new Set(prev);
      newSet.delete(currentTabId);

      if (nextTab && !completedTabs.has(nextTab.id)) {
        newSet.add(nextTab.id);
      }

      return newSet;
    });
  };

  const goToPrevTab = (currentTabId: number) => {
    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }

    const currentIndex = visibleTabs.findIndex((t) => t.id === currentTabId);
    if (currentIndex < 0) return;
    const prevTab = visibleTabs[currentIndex - 1];

    configurator.deselectWalls();

    if (currentTabId === 5) {
      configurator.resetCamera();
    }

    setActiveTabs((prev) => {
      const newSet = new Set(prev);
      newSet.delete(currentTabId);

      if (prevTab) {
        newSet.add(prevTab.id);
      }

      return newSet;
    });

    if (prevTab && completedTabs.has(prevTab.id)) {
      const newSet = new Set(completedTabs);
      newSet.delete(prevTab.id);
      setCompletedTabs(newSet);
    }
  };

  useEffect(() => {
    const uncompletedTabs = new Set(
      tabsData
        .filter((t) => !completedTabs.has(t.id) && t.id !== 7)
        .map((t) => t.id)
    );
    setUncompletedTabs(uncompletedTabs);
  }, [activeTabs, completedTabs, setUncompletedTabs]);

  return (
    <>
      {/* <Scrollbars
        key={"tabs-scrollbars"}
        // autoHeight"
        // autoHeightMin={300}
        // autoHeightMax={700}
        ref={scrollRef}
      > */}
      <div
        className="scroll"
        // ref={scrollRef}
      >
        <div className="tabs-container" onClick={handleOutWandenClick}>
          {visibleTabs.map((tab, index) => {
            const isActive = activeTabs.has(tab.id);
            const isCompleted = completedTabs.has(tab.id);
            const hasPrev = index > 0 && isActive && tab.id !== 7;

            return (
              <Tab
                key={`main-tab-${tab.id}`}
                tab={tab}
                isActive={isActive}
                onClick={() => handleTabClick(tab.id)}
                hidden={false}
                onNext={tab.id !== 7 ? goToNextTab : undefined}
                onPrev={isActive && hasPrev ? goToPrevTab : undefined}
                isCompleted={isCompleted}
                description={tab.description}
              />
            );
          })}
        </div>
      </div>
      {/* </Scrollbars> */}
    </>
  );
};

export default Tabs;
